import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const tabTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      backgroundColor: theme.color.surface[2],
      textColor: theme.color.text.core['-secondary'],
      tabContainerBG: theme.color.surface[2],
      tabSelectedText: theme.color.text.core['-primary'],
    },
  ]),
);
